import React from "react";
import analytics from "web/script/analytics/analytics";
import { showMainNavigation, hideMainNavigation } from "web/redux/ducks/main-navigation";
import withReduxProvider from "web/react/redux-provider";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import styles from "./main-navigation-toggle-mobile.css";
var MENU_OPENED = "opened";
var MENU_CLOSED = "closed";

function extractNavigation(state) {
  return state.mainNavigationReducer;
}

export function MainNavigationToggleMobile() {
  var _useReduxSelector = useReduxSelector(extractNavigation),
      selectedGender = _useReduxSelector.selectedGender,
      visible = _useReduxSelector.visible;

  var dispatch = useDispatch();

  function sendAnalytics(menuVisibility) {
    var gender = selectedGender || "women";
    analytics.event("nav", menuVisibility, "nav_".concat(gender.toLowerCase(), "_menu"));
  }

  function toggleVisibility() {
    if (visible) {
      dispatch(hideMainNavigation());
      document.body.classList.remove("no-scroll");
      sendAnalytics(MENU_CLOSED);
    } else {
      dispatch(showMainNavigation());
      document.body.classList.add("no-scroll");
      sendAnalytics(MENU_OPENED);
    }
  }

  return React.createElement("button", {
    className: visible ? styles.burgerCross : styles.burgerContainer,
    onClick: function onClick() {
      return toggleVisibility();
    }
  }, React.createElement("div", {
    className: styles.burgerBar1
  }), React.createElement("div", {
    className: styles.burgerBar2
  }), React.createElement("div", {
    className: styles.burgerBar3
  }));
}
export default withReduxProvider(MainNavigationToggleMobile);